import React, { FC } from 'react';
import { Box, Container, Divider, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { NewsSinglePost } from 'services/news/types';

interface NewsContentArrayProps {
  post: NewsSinglePost;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(10),
  },
  title: {
    marginBottom: theme.spacing(4),
    color: theme.palette.common.black,
    fontWeight: 500,
  },
  text: {
    marginBottom: theme.spacing(6),
    '& h2': {
      fontSize: 32,
      color: '#111133',
    },
    '& h3': {
      fontSize: 28,
      color: '#111133',
    },
    '& h6': {
      fontSize: 18,
      color: theme.palette.primary.dark,
    },
    '& p': {
      fontSize: 15,
      marginBottom: theme.spacing(3),
      color: theme.palette.primary.dark,
      '& em': {
        fontWeight: 400,
      },
      '& a': {
        color: '#0000FF',
        borderBottom: '1px solid #0000FF',
        '& span': {
          color: '#0000FF !important',
          borderBottom: '1px solid #0000FF',
        },
      },
    },
    '& span': {
      color: theme.palette.common.black,
    },
    '& ul': {
      paddingLeft: theme.spacing(2),
      margin: 0,
      '& li': {
        fontSize: 15,
        '&::marker': {
          fontSize: 10,
        },
      },
      '& li::marker': {
        fontSize: 15,
        lineHeight: 1,
        color: '#606060',
      },
      '& li:not(:last-child)': {
        marginBottom: 10,
      },
    },
    '& blockquote': {
      position: 'relative',
      margin: 0,
      '& p': {
        fontWeight: 500,
        color: '#606060',
        fontStyle: 'italic',
        '&::before': {
          content: 'open-quote',
        },
        '&::after': {
          content: 'close-quote',
        },
      },
    },
    '& img': {
      maxWidth: '100%',
      objectFit: 'contain',
      height: 'auto',
    },
  },
  divider: {
    backgroundColor: theme.palette.secondary.light,
  },
}));

const NewsContentSection: FC<NewsContentArrayProps> = ({ post }) => {
  const classes = useStyles({});
  const { title, content_description } = post;

  return (
    <Box key={post.id}>
      <Container fixed className={classes.root}>
        <Grid container justify="center" direction="row">
          <Grid md={8} xs={12} item>
            <Typography className={classes.title} variant="h2">
              {title}
            </Typography>
            {content_description && (
              <>
                <Typography className={classes.text} color="textSecondary">
                  {content_description}
                </Typography>
                <Box mb={6}>
                  <Divider className={classes.divider} />
                </Box>
              </>
            )}
            <div key={post.id} className={classes.text} dangerouslySetInnerHTML={{ __html: post.content }} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default NewsContentSection;
